// extracted by mini-css-extract-plugin
export default {"declinePage":"DeclinePage_declinePage__OVDlI"};